<div class="position-relative">
  <div class="container d-xs-flex align-items-xs-center min-height-xs-100vh">
      <div class="row pt-10 pb-2 mx-auto" style="text-align: center;">
        <h1 style="font-weight: bold;">Kopa Tours Privacy Policy</h1>
      </div>
      <div class="container space-bottom-2 px-lg-12">
        <div class="row my-4 mt-4">
          <div class="col-12 col-lg-12 p-6 transparent-card">
          <p class="mainBody">
            At Kopa Tours, the privacy of your data is of extreme importance to us.
            This privacy policy document outlines the types of personal information that are
            received and collected by Kopa Tours and how that data is used.
            </p>
            <br/>
            <h2 class="porterHeader">Email</h2>
            <br/>
              <p class="mainBody">If you opt-in to emails from Kopa Tours, we collect your contact information;
                email and name. We won't spam you, and we do not sell or give you information to other affiliates.
              </p>
              <p class="mainBody">You may withdraw your consent to be emailed or change your preferences at any time by
                clicking the Unsubscribe button at the bottom of any of our emails, or by emailing us as
                <a href="mailto:contact@kopatours.com"><u>contact@kopatours.com</u></a>.
              </p>
            <br/>
            <h2 class="porterHeader">Log Files</h2>
            <br/>
              <p class="mainBody">Like many other web sites, Kopa Tours makes use of log files.
                The information inside the log files includes internet protocol (IP) addresses,
                types of browsers, your Internet Service Provider (ISP), date/time stamps,
                referring/exit pages, and the number of clicks to analyze trends, administer the
                site, track user’s movement around the site, and gather demographic information.
                IP addresses and other such information are not linked to any information that is
                personally identifiable, and you are completely anonymous.</p>
            <br/>
            <h2 class="porterHeader">Cookies and Web Beacons</h2>
            <br/>
            <p class="mainBody">
            Kopa Tours does use cookies to store information about visitors preferences, record
            user-specific information on which pages the user accesses or visits, customize web page
            content based on visitors browser type or other information that the visitor sends via
            their browser.
            </p>
            <br/>
            <p class="mainBody">
            If you wish to disable cookies, you may do so through your individual browser options.
            More detailed information about cookie management with specific web browsers can be found
            at the browser’s respective websites.
            </p>
            <br/>
            <p class="mainBody">
              If you would like to know more information, or have any questions, comments, or concerns,
              please email us at <a href="mailto:contact@kopatours.com"><u>contact@kopatours.com</u></a>.
          </p>
          </div>
        </div>
      </div>
  </div>
</div>
